import { render, staticRenderFns } from "./ImageBlock.vue?vue&type=template&id=05862c0a"
import script from "./ImageBlock.vue?vue&type=script&lang=js"
export * from "./ImageBlock.vue?vue&type=script&lang=js"
import style0 from "./ImageBlock.vue?vue&type=style&index=0&id=05862c0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports